import { render, staticRenderFns } from "./settingWorkDocsSchemeType.vue?vue&type=template&id=548559e3&"
import script from "./settingWorkDocsSchemeType.vue?vue&type=script&lang=js&"
export * from "./settingWorkDocsSchemeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports